<div id="appComponent" [ngClass]="customThemeName">
  <app-loader></app-loader>
  <!-- The routed screen is inserted as a sibling after `<router-outlet>`, so it lands inside this
       block and takes the height the shell's flex column gives it. -->
  <div class="app-main">
    <router-outlet></router-outlet>
  </div>
  @if (hasCustomUI() && advBanner()) {
    <app-advertisement-banner></app-advertisement-banner>
  }
  <app-footer></app-footer>
</div>
